import { TenantConfig, TenantSlug } from './types';
import { defaultConfig } from './default';
import { kidsConfig } from './kids';

/**
 * Mapeo de dominios a configuraciones de tenant
 */
const TENANT_MAP: Record<string, TenantConfig> = {
  'neureka.es': defaultConfig,
  'www.neureka.es': defaultConfig,
  'kids.neureka.es': kidsConfig,
  'localhost': defaultConfig,        // Para desarrollo local
  '127.0.0.1': defaultConfig,       // Para desarrollo local
};

/**
 * Mapeo de slugs a configuraciones (para acceso directo)
 */
const TENANT_BY_SLUG: Record<TenantSlug, TenantConfig> = {
  default: defaultConfig,
  kids: kidsConfig,
  senior: defaultConfig, // TODO: Implementar cuando esté listo
  pro: defaultConfig,    // TODO: Implementar cuando esté listo
};

/**
 * Detecta el tenant basándose en el hostname actual
 * @param hostname - El hostname de la URL (ej: 'kids.neureka.es')
 * @returns La configuración del tenant correspondiente
 */
export function getTenantByDomain(hostname?: string): TenantConfig {
  const domain = hostname || window.location.hostname;

  // PRIMERO: Verificar parámetro ?tenant en localhost (desarrollo)
  if (domain.includes('localhost') || domain.includes('127.0.0.1')) {
    const params = new URLSearchParams(window.location.search);
    const tenantParam = params.get('tenant') as TenantSlug | null;

    if (tenantParam && TENANT_BY_SLUG[tenantParam]) {
      console.log(`🔧 Usando tenant desde parámetro: ${tenantParam}`);
      return TENANT_BY_SLUG[tenantParam];
    }
  }

  // Intentar match por subdominio
  if (domain.includes('kids.')) {
    return kidsConfig;
  }

  // Intentar match exacto
  if (TENANT_MAP[domain]) {
    return TENANT_MAP[domain];
  }

  // Por defecto, retornar configuración default
  return defaultConfig;
}

/**
 * Obtiene configuración de tenant por slug
 * @param slug - El identificador del tenant ('default', 'kids', etc)
 * @returns La configuración del tenant
 */
export function getTenantBySlug(slug: TenantSlug): TenantConfig {
  return TENANT_BY_SLUG[slug] || defaultConfig;
}

/**
 * Verifica si el tenant actual es Kids
 */
export function isKidsTenant(): boolean {
  const tenant = getTenantByDomain();
  return tenant.slug === 'kids';
}

/**
 * Verifica si el tenant actual es Default (adultos)
 */
export function isDefaultTenant(): boolean {
  const tenant = getTenantByDomain();
  return tenant.slug === 'default';
}

// Exportaciones
export { defaultConfig, kidsConfig };
export type { TenantConfig, TenantSlug } from './types';
